/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITIALSTATE = {
    list: [],
};

export default function pendingReservation(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case types.ISSUANCE_LIST_CREATED:
            st.list = [...action.payload];
            delete st.err;
            return st;
        case types.POST_ISSUANCE_ERROR:
            st.err = action.payload;
            return st;
        case types.CLEAR_ISSUANCE_LIST:
            st.list = [];
            delete st.err;
            delete st.displayValidation;
            return st;
        case types.DISPLAY_UI_VALIDATIONS:
            st.displayValidation = true;
            return st;
        case types.CLEAR_DISPLAY_UI_VALIDATION:
            delete st.displayValidation;
            return st;
        default:
            return st;
    }
}
